export const plan = [

  {
    title: "Pro",
    description:
      "Provisionamento de usuários & SSO para aplicativos e sistemas.",
    priceMonth: "$3.50/a.m",
    priceAnnual: "$42/a.a",
    buttonText: "Conheça",
  },
  {
    title: "Entrepise",
    description:
      "Provisionamento de usuários & SSO para aplicativos e sistemas com SLA 24x7.",
    priceMonth: "Entre em contato",
    priceAnnual: "",
    buttonText: "Conheça",
  },
];

// export const planAnnual = [

//   {
//     title: "Pro",
//     description:
//       "Provisionamento de usuários & SSO para aplicativos e sistemas.",
//     price: "$42.0/anual",
//     buttonText: "Conheça",
//   },
//   {
//     title: "Entrepise",
//     description:
//       "Provisionamento de usuários & SSO para aplicativos e sistemas com SLA 24x7.",
//     price: "Entre em contato",
//     buttonText: "Conheça",
//   },
// ];
